import { Voni } from '../client';

export interface Invitation {
  id: number;
  project_id: number;
  email: string;
  role: string;
  status: 'pending' | 'accepted' | 'expired';
  token: string;
  invited_by: number;
  expires_at: string;
  created_at: string;
}

export interface InvitationCreateInput {
  email: string;
  role: 'admin' | 'member' | 'viewer';
}

export class InvitationResource {
  constructor(private client: Voni) {}

  async list(projectId: string | number): Promise<Invitation[]> {
    return this.client.request<Invitation[]>('GET', `/projects/${projectId}/invitations`);
  }

  async invite(projectId: string | number, email: string, role: 'admin' | 'member' | 'viewer' = 'member'): Promise<Invitation> {
    const data: InvitationCreateInput = { email, role };
    return this.client.request<Invitation>('POST', `/projects/${projectId}/invitations`, undefined, data);
  }

  async revoke(projectId: string | number, invitationId: number): Promise<void> {
    await this.client.request('DELETE', `/projects/${projectId}/invitations/${invitationId}`);
  }
}
